var _a, _b;
import { PaymentBrand, CardBrand } from '../types';
var cardBrandToPaymentBrandMap = (_a = {},
    _a[CardBrand.AMEX] = PaymentBrand.AMEX,
    _a[CardBrand.Visa] = PaymentBrand.VISA,
    _a[CardBrand.MasterCard] = PaymentBrand.MASTERCARD,
    _a[CardBrand.Discover] = PaymentBrand.DISCOVER,
    _a[CardBrand.JCB] = PaymentBrand.JCB,
    _a[CardBrand.Diners] = PaymentBrand.DINERS,
    _a[CardBrand.CARTE_BLUE] = PaymentBrand.CARTE_BLUE,
    _a[CardBrand.ELO] = PaymentBrand.ELO,
    _a[CardBrand.SOLO] = PaymentBrand.SOLO,
    _a[CardBrand.UnionPay] = PaymentBrand.UNIONPAY,
    _a[CardBrand.BANCARD] = PaymentBrand.BANCARD,
    _a[CardBrand.ENROUTE] = PaymentBrand.ENROUTE,
    _a[CardBrand.MASTERO] = PaymentBrand.MAESTRO,
    _a[CardBrand.VISA_DELTA] = PaymentBrand.VISA,
    _a[CardBrand.ELECTRON] = PaymentBrand.UNKNOWN,
    _a[CardBrand.MAESTR_UK] = PaymentBrand.UNKNOWN,
    _a[CardBrand.SBI_MAESTRO] = PaymentBrand.UNKNOWN,
    _a);
export var isCreditCardBrandMap = (_b = {},
    _b[PaymentBrand.AMEX] = true,
    _b[PaymentBrand.VISA] = true,
    _b[PaymentBrand.MASTERCARD] = true,
    _b[PaymentBrand.DISCOVER] = true,
    _b[PaymentBrand.JCB] = true,
    _b[PaymentBrand.DINERS] = true,
    _b[PaymentBrand.CARTE_BLUE] = true,
    _b[PaymentBrand.ELO] = true,
    _b[PaymentBrand.SOLO] = true,
    _b[PaymentBrand.UNIONPAY] = true,
    _b[PaymentBrand.BANCARD] = true,
    _b[PaymentBrand.ENROUTE] = true,
    _b[PaymentBrand.MAESTRO] = true,
    _b[PaymentBrand.BOLETO] = false,
    _b[PaymentBrand.MP_OXXO] = false,
    _b[PaymentBrand.MERCADO_PAGO_RECURRING] = false,
    _b[PaymentBrand.YANDEX] = false,
    _b[PaymentBrand.BANK_TRANSFER] = false,
    _b[PaymentBrand.MP_SERFIN] = false,
    _b[PaymentBrand.MP_BANCOMER] = false,
    _b[PaymentBrand.MP_BANAMEX] = false,
    _b[PaymentBrand.SEPA_DIRECT_DEBIT] = false,
    _b[PaymentBrand.PAYPAL] = false,
    _b[PaymentBrand.REG_DOT_RU] = false,
    _b[PaymentBrand.SOFORT] = false,
    _b[PaymentBrand.CREDITS_PREPAID_CARD] = false,
    _b[PaymentBrand.UNKNOWN] = false,
    _b);
export var cardBrandToPaymentBrandMapper = function (cardBrand) {
    return cardBrandToPaymentBrandMap[cardBrand];
};
//# sourceMappingURL=cardBrandToPaymentBrandMapper.js.map